module.exports = __webpack_public_path__ + "img/warning-sign.60be548f.svg";